export default __webpack_public_path__ + "static/media/popover-red.0bf2b73d.png";